<div id="unauthorized-header" class="flex justify-between w-full p-4 px-8">
  <app-logo [isLogin]="false"/>
  <div class="ml-auto flex items-center space-x-4">
    <div class="flex gap-2">
      @if (!isCurrentPageHref('sign-in')) {
        <button [routerLink]="['/sign-in']" id="navbar-signing-btn"
                class="navbar-action-item special-font">
          Sign In
        </button>
      }
      @if (!isCurrentPageHref('register')) {
        <button [routerLink]="['/register']" id="navbar-register-btn"
                class="navbar-action-item special-font px-4 py-2">
          Request an Account
        </button>
      }
    </div>
  </div>
</div>
